// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Uf62","search":"Settings_search__3XP1Y","filter":"Settings_filter__1MXMd"};